/**
 * @generated SignedSource<<73afa4c410419b1a44a152cc0bf9d40b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type NonReferralAcceptancePartner_referral$data = {
  readonly company: {
    readonly displayName: string;
  } | null;
  readonly recipientDisplayName: string;
  readonly " $fragmentType": "NonReferralAcceptancePartner_referral";
};
export type NonReferralAcceptancePartner_referral$key = {
  readonly " $data"?: NonReferralAcceptancePartner_referral$data;
  readonly " $fragmentSpreads": FragmentRefs<"NonReferralAcceptancePartner_referral">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "NonReferralAcceptancePartner_referral",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "recipientDisplayName",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "CompanyNode",
      "kind": "LinkedField",
      "name": "company",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "displayName",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "IndifyToPartnerReferralNode",
  "abstractKey": null
};

(node as any).hash = "53b3aa52ca3267ddd2a14825cb815584";

export default node;
